<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M12.4001 8.40039L14.0001 10.0004M14.0001 10.0004L12.4001 11.6004M14.0001 10.0004H6.00012M6.00012 10.0004L7.60012 8.40039M6.00012 10.0004L7.60012 11.6004" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.5 5.5V14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M17.5 5.5V14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TimeRunningIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>